import { useCallback, useEffect, useState } from 'react';

import { REFRESH_EMAIL_TICKET_TAGS } from '@/constants/event-bus';
import { getEmailDisputeTicketConfig } from '@/services/email-dispute';
import eventBus from '@/utils/eventBus';
import { globalCache } from '@/utils/utils';
import { debounce } from 'lodash-es';

export default () => {
  const [tableDefaultData, setTableDefaultData] = useState<any>({});
  const [systemTag, setSystemTag] = useState<string[]>([]);
  const [customTag, setCustomTag] = useState<string[]>([]);
  const [customTagDelete, setCustomTagDelete] = useState<string[]>([]);
  const [emailTicketAiTag, setEmailTicketAiTag] = useState<string[]>([]);
  const [emailTicketOrderTag, setEmailTicketOrderTag] = useState<string[]>([]);

  const fetchTags = useCallback(async () => {
    const { email_ticket_sys_tag, email_ticket_tag, email_ticket_ai_tag, email_ticket_tag_delete, email_ticket_order_tag } =
      await getEmailDisputeTicketConfig();

    return {
      systemTag: email_ticket_sys_tag,
      customTag: email_ticket_tag,
      customTagDelete: email_ticket_tag_delete,
      emailTicketAiTag: email_ticket_ai_tag,
      emailTicketOrderTag: email_ticket_order_tag
    };
  }, []);

  const refreshTags = debounce(async () => {
    let email_ticket_sys_tag = [],
      email_ticket_tag = [],
      email_ticket_ai_tag = [],
      email_ticket_tag_delete = [],
      email_ticket_order_tag = [];

    try {
      const cancelRequestRefreshTags = globalCache.get(`cancelRequestRefreshTags`);

      cancelRequestRefreshTags?.();
      const { run, cancel } = await getEmailDisputeTicketConfig(undefined, true);
      globalCache.set(`cancelRequestRefreshTags`, cancel);
      const data = await run();
      email_ticket_sys_tag = data.email_ticket_sys_tag;
      email_ticket_tag = data.email_ticket_tag;
      email_ticket_ai_tag = data.email_ticket_ai_tag;
      email_ticket_tag_delete = data.email_ticket_tag_delete;
      email_ticket_order_tag = data.email_ticket_order_tag;
    } catch {
    } finally {
      setSystemTag(email_ticket_sys_tag);
      setCustomTag(email_ticket_tag);
      setEmailTicketAiTag(email_ticket_ai_tag);
      setCustomTagDelete(email_ticket_tag_delete);
      setEmailTicketOrderTag(email_ticket_order_tag);
      return {
        orderTag: email_ticket_order_tag || [],
        systemTag: email_ticket_sys_tag,
        customTag: email_ticket_tag,
        emailTicketAiTag: email_ticket_ai_tag,
        customTagDelete: email_ticket_tag_delete,
        emailTicketOrderTag: email_ticket_order_tag,
      };
    }
  }, 500);

  useEffect(() => {
    // 监听事件总线，刷新标签
    eventBus.on(REFRESH_EMAIL_TICKET_TAGS, refreshTags);
  }, []);

  return {
    systemTag,
    emailTicketAiTag,
    emailTicketOrderTag,
    customTag,
    customTagDelete,
    refreshTags,
    setSystemTag,
    setCustomTag,

    setCustomTagDelete,
    fetchTags,
    tableDefaultData,
    setTableDefaultData
  };
};
